<template>
    <Primitive
        :as="as"
        :class="block()"
    >
        <div
            v-if="$slots.media"
            :class="element('media')"
        >
            <slot name="media" />
        </div>

        <div :class="element('inner')">
            <KEyebrow
                v-if="$slots.eyebrow || eyebrow"
                variant="on-media"
                :class="element('eyebrow')"
            >
                <span :class="element('eyebrow-dot')" />
                <slot name="eyebrow">
                    {{ eyebrow }}
                </slot>
            </KEyebrow>

            <component
                :is="titleAs"
                v-if="$slots.title || title"
                class="k-display"
                :class="[element('title')]"
            >
                <slot name="title">
                    {{ title }}
                </slot>
            </component>

            <div
                v-if="$slots.default || text"
                class="k-text-lg k-prose"
                :class="[element('text')]"
            >
                <slot>{{ text }}</slot>
            </div>

            <div
                v-if="$slots.content"
                :class="element('content')"
            >
                <slot name="content" />
            </div>

            <div
                v-if="$slots.footer"
                :class="element('footer')"
            >
                <slot name="footer" />
            </div>
        </div>
    </Primitive>
</template>

<script setup lang="ts">
import type { KHeroProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'
import KEyebrow from '../eyebrow/k-eyebrow.vue'

defineOptions({ name: 'KHero' })

withDefaults(defineProps<KHeroProps>(), {
    as: 'section',
    titleAs: 'h1',
})

defineSlots<{
    default?: () => unknown
    content?: () => unknown
    eyebrow?: () => unknown
    footer?: () => unknown
    media?: () => unknown
    title?: () => unknown
}>()

const { block, element } = useBem('k-hero')
</script>

<style lang="scss">
@use './k-hero.scss';
</style>
